module.exports = "/assets/data/9748f37e130e9ede91e060c35f271d09-KW15.data.json";